const getElQuantity = event => parseInt($(event.target).parent().find('.quantity').val(), 10);

const getElLimitQuantity = (event, limit) => parseInt($(event.target).parent().data(limit), 10);

const modifyQuantity = (event, condition, amount, quantity) => {
    const quantityEl = $(event.target).parent().find('.quantity');
    if (condition) {
        quantityEl.val(quantity + amount);
        quantityEl.trigger('change');
    }
};

module.exports = {
    assignEvents() {
        const docBody = $(document.body);
        const moreClass = '.more-btn';
        const lessClass = '.less-btn';

        docBody.off(moreClass).on('click', moreClass, (event) => {
            const quantity = getElQuantity(event);
            const maxquantity = getElLimitQuantity(event, 'maxquantity');

            modifyQuantity(event, quantity < maxquantity, 1, quantity);
        });

        docBody.off(lessClass).on('click', lessClass, (event) => {
            const quantity = getElQuantity(event);
            const minquantity = getElLimitQuantity(event, 'minquantity');
            modifyQuantity(
                event,
                quantity > minquantity && quantity > 1,
                -1,
                quantity,
            );
        });

        docBody.on('click', '.info-tooltip', () => {
            $('.tooltiptext').toggleClass('visible');
        });
    },
};
